import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: "Внесение суммы к оплате",
    loading: _ctx.isLoading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitSubmitted
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        class: "w-full mb-2",
        placeholder: _ctx.getPlaceholder,
        value: _ctx.state.paid_price,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.paid_price) = $event)),
        "is-invalid": _ctx.state_form$.paid_price.$error,
        "validation-errors": _ctx.state_form$.paid_price.$errors
      }, null, 8, ["placeholder", "value", "is-invalid", "validation-errors"])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}